import CustomHead from "../CustomHead";

function VanillaLayout(props) {
  const { children, title, description, image, isCustomTitle, ...rest } = props;

  return (
    <div {...rest}>
      <CustomHead title={title} description={description} isCustomTitle={isCustomTitle} image={image} />
      {children}
    </div>
  );
}

export default VanillaLayout;
